import { render, staticRenderFns } from "./gtr-glossary.vue?vue&type=template&id=1d69e0da&scoped=true"
import script from "./gtr-glossary.ts?vue&type=script&lang=ts&external"
export * from "./gtr-glossary.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-glossary.vue?vue&type=style&index=0&id=1d69e0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d69e0da",
  null
  
)

export default component.exports